enum StoneCategorization {
	MeasuredDuringSurvey = "MeasuredDuringSurvey",

    MeasuredDuringSurveyInAbsentia = "MeasuredDuringSurveyInAbsentia",

    MeasuredAfterInstallation = "MeasuredAfterInstallation",

    MeasuredAfterInstallationInAbsentia = "MeasuredAfterInstallationInAbsentia",

    MeasuredDuringSurveyNotInStock = "MeasuredDuringSurveyNotInStock",

    MeasuredDuringSurveyNotInStockInAbsentia = "MeasuredDuringSurveyNotInStockInAbsentia",

    MeasuredAfterInstallationNotInStock = "MeasuredAfterInstallationNotInStock",

    MeasuredAfterInstallationNotInStockInAbsentia = "MeasuredAfterInstallationNotInStockInAbsentia",

    MeasuredDuringSurveyExtern = "MeasuredDuringSurveyExtern",

    MeasuredDuringSurveyExternInAbsentia = "MeasuredDuringSurveyExternInAbsentia",

    MeasuredAfterInstallationExtern = "MeasuredAfterInstallationExtern",

    MeasuredAfterInstallationExternInAbsentia = "MeasuredAfterInstallationExternInAbsentia",
}

export default StoneCategorization;